'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5;

import styled from 'styled-components';
import StandardProductPageTitle from 'pricing-pages-unified-ui/components/product-pages/StandardProductPageTitle';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import UIImage from 'UIComponents/image/UIImage';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import { useSelector } from 'react-redux';
import { isMon569VariantSelector } from '../../../selectors/ExperimentTreatmentSelectors'; //The first block of styles are needed for IE fallback

const StyledFlex = styled.div.withConfig({
  displayName: "CrmSuiteTitle__StyledFlex",
  componentId: "w84xfm-0"
})(["flex-wrap:wrap;max-width:100%;text-align:center;display:grid;align-items:baseline;grid-template-columns:repeat(auto-fit,minmax(0,1fr));grid-row-gap:15px;margin-bottom:24px;> *{width:auto;}", " ", ""], breakpoint.cs(_t || (_t = _`
    justify-content: ${0};
    margin-top: 40px;
  `), ({
  isMon569Variant
}) => isMon569Variant ? 'center' : undefined), breakpoint.phoneLarge(_t2 || (_t2 = _`
    display: none;
  `)));
const HubTitleContainer = styled(UIFlex).withConfig({
  displayName: "CrmSuiteTitle__HubTitleContainer",
  componentId: "w84xfm-1"
})(["align-items:center;margin:auto;"]);
const Mon569HubTitleContainer = styled(UIFlex).withConfig({
  displayName: "CrmSuiteTitle__Mon569HubTitleContainer",
  componentId: "w84xfm-2"
})(["align-items:center;"]);
const CenteredDiv = styled.div.withConfig({
  displayName: "CrmSuiteTitle__CenteredDiv",
  componentId: "w84xfm-3"
})(["text-align:center;", ""], breakpoint.phoneLarge(_t3 || (_t3 = _`
    display: none;
  `)));
const StyledProductPageTitle = styled(StandardProductPageTitle).withConfig({
  displayName: "CrmSuiteTitle__StyledProductPageTitle",
  componentId: "w84xfm-4"
})(["", " ", ""], breakpoint.cs(_t4 || (_t4 = _`
    display: ${0}
  `), ({
  isMon569Variant
}) => isMon569Variant ? 'none' : undefined), breakpoint.tablet(_t5 || (_t5 = _`
    display: none;
  `)));
export const CrmSuiteTitle = () => {
  const isMon569Variant = useSelector(isMon569VariantSelector);
  const HubTitleContainerToUse = isMon569Variant ? Mon569HubTitleContainer : HubTitleContainer;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledProductPageTitle, {
      showIcon: false,
      isCrmSuite: true,
      align: "center",
      isMon569Variant: isMon569Variant
    }), /*#__PURE__*/_jsx(CenteredDiv, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crmSuite.includesFreeToolsPlus"
      })
    }), /*#__PURE__*/_jsxs(StyledFlex, {
      children: [/*#__PURE__*/_jsxs(HubTitleContainerToUse, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-bottom-1",
          src: ProductLinePageIcons[MARKETING],
          height: 25
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.products.tabs.marketing.pageTitle"
          })
        })]
      }), /*#__PURE__*/_jsxs(HubTitleContainerToUse, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-bottom-1",
          src: ProductLinePageIcons[SALES],
          height: 25
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.products.tabs.sales.pageTitle"
          })
        })]
      }), /*#__PURE__*/_jsxs(HubTitleContainerToUse, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-bottom-1",
          src: ProductLinePageIcons[SERVICE],
          height: 25
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.products.tabs.service.pageTitle"
          })
        })]
      }), /*#__PURE__*/_jsxs(HubTitleContainerToUse, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-bottom-1",
          src: ProductLinePageIcons[CMS],
          height: 25
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.products.tabs.cmsHub.pageTitle"
          })
        })]
      }), /*#__PURE__*/_jsxs(HubTitleContainerToUse, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-bottom-1",
          src: ProductLinePageIcons[OPERATIONS],
          height: 25
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.products.tabs.operations.pageTitle"
          })
        })]
      })]
    })]
  });
};